const FAQS = [
  {
    q: '韩漫导航收录了哪些韩漫网站？',
    a: '我们收录了韩漫网、韩漫之家、韩漫屋、韩漫吧等主流韩漫漫画网站，覆盖免费韩漫网址和付费平台的入口汇总，持续更新中。',
  },
  {
    q: '韩漫在线观看需要付费吗？',
    a: '导航中的大部分平台提供免费韩漫画网址在线观看，部分站点可能有付费抢先看或VIP章节，具体以各平台规则为准。建议优先浏览免费韩漫网址合集。',
  },
  {
    q: '如何找到最新更新的韩漫？',
    a: '您可以通过本页"更新动态"模块查看每日韩漫更新快讯，或在"人气榜单"中查看当前最热门的韩漫作品排名，快速定位最新内容。',
  },
  {
    q: '韩漫导航支持手机访问吗？',
    a: '完全支持。页面适配手机、平板及桌面端，您可以通过移动端韩漫入口随时随地浏览韩漫网站大全，追更体验流畅。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            关于韩漫导航平台的常见疑问解答
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-4">
          {FAQS.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}